import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";
import Gravatar from "react-gravatar";
import Card from "react-bootstrap/Card";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
  }

  componentDidMount() {
    this.props.uzer;
  }

  render() {
    const { uzer } = this.props;
    return (
      <div className="container-fluid">
        <Navbar className="bg-info justify-content-between">
          <Navbar.Brand>
            {uzer.first_name} {uzer.last_name}
          </Navbar.Brand>
          <Link to="/stats">
            <Button variant="outline-light">Back to Stakeholders</Button>
          </Link>
        </Navbar>

        <Form>
          <Form.Row>
            <Col />
            <Card
              className="mb-2 mt-2"
              as={Col}
              // bg="light"
              // border="info"
              // body="true"
              style={{ minWidth: "250px", maxWidth: "250px" }}
            >
              <Gravatar
                default={"mp"}
                email={uzer.email}
                size={250}
                className="card-img-top"
              />
            </Card>
            <Col />
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                readOnly
                name="first_name"
                value={uzer.first_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control name="last_name" readOnly value={uzer.last_name} />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                readOnly
                value={uzer.email ? uzer.email : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridStore">
              <Form.Label>Inputted Store</Form.Label>
              <Form.Control
                name="inputted_store"
                readOnly
                value={uzer.inputted_store ? uzer.inputted_store : ""}
              />
            </Form.Group>
            {uzer.accepted_terms && (
              <Form.Group as={Col} controlId="formGridTerms">
                <Form.Label>Accepted Terms</Form.Label>
                <Form.Control
                  name="accepted_terms"
                  readOnly
                  value={uzer.accepted_terms}
                />
              </Form.Group>
            )}

            <Form.Group as={Col} controlId="formGridMerchantId">
              <Form.Label>Merchant ID</Form.Label>
              <Link to={`/merchants/${uzer.merchant_id}`}>
                <Form.Control
                  name="merchant_id"
                  readOnly
                  value={uzer.merchant_id ? uzer.merchant_id : ""}
                />
              </Link>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridAdmin">
              <Form.Label>Admin</Form.Label>
              <Form.Control
                name="admin"
                readOnly
                value={uzer.admin ? "true" : "false"}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridDriver">
              <Form.Label>Driver</Form.Label>
              <Form.Control
                name="driver"
                readOnly
                value={uzer.driver ? "true" : "false"}
              />
            </Form.Group>
            {uzer.driver && (
              <Form.Group as={Col} controlId="formGridDriverID">
                <Form.Label>Driver ID</Form.Label>
                <Form.Control
                  name="driver_id"
                  readOnly
                  value={uzer.driver_id}
                />
              </Form.Group>
            )}
          </Form.Row>
        </Form>
      </div>
    );
  }
}

export default withRouter(UserProfile);
